module.exports = __webpack_public_path__ + "static/img/qrcode1.95f9ecdb.png";